// extracted by mini-css-extract-plugin
export default {"UpdateInfo":"s-kd6Qd6mvM5kfXwevM-0w=="};